import * as types from './types';
import { fetchGeneric } from 'State/generic/actions';

export const getColors = colorType => {
  return dispatch => {
    dispatch(
      fetchGeneric(
        types.COLOR_FETCH,
        types.COLOR_FETCHING,
        types.COLOR_FETCH_ERROR,
        `serveditem/colors/${colorType}`
      )
    );
  };
};

export const writeColors = (colorType, itemColors) => {
  return dispatch => {
    dispatch(
      fetchGeneric(
        types.COLOR_SAVE,
        types.COLOR_FETCHING,
        types.COLOR_FETCH_ERROR,
        `serveditem/writecolors`,
        { enumColorType: colorType, lstServedItemColor: itemColors }
      )
    );
    dispatch({ type: types.COLOR_SET_SUCCESS });
  };
};

export const setColorType = newColorType => {
  return { type: types.COLOR_SETUP_SET_COLOR_TYPE, payload: newColorType };
};

export const resetSuccess = () => {
  return { type: types.COLOR_RESET_SUCCESS };
};



// WEBPACK FOOTER //
// ./src/pages/serveditemsetup/state/colorsetup/actions.js